module.exports = __webpack_public_path__ + "img/button-smartitemapi.26618906.jpg";